<template>
  <v-card
    style="width: 300px; position: relative; border-radius: 10px"
    :style="{
      border: active ? '1px solid black' : 'inherit',
    }"
  >
    <v-card-title>{{ title }}</v-card-title>
    <v-divider></v-divider>
    <div class="pa-3">{{ price }}</div>
    <v-divider></v-divider>
    <div class="pa-3" style="height: 280px">
      <slot name="features" />
    </div>
    <div
      style="
        position: absolute;
        bottom: 10px;
        right: 10px;
        left: 10px;
        text-align: center;
      "
    >
      <slot name="cta" v-if="!active" />
      <i v-else>Active plan</i>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ["title", "price", "active"],
};
</script>